import {
  resolveBool,
  resolveColorName,
  resolveLink,
  resolveRTC,
  resolveTheme,
} from '@/utils/resolvers';

export const NEWS_RIBBON_MAPPER = ({ params, document, isTransparent }: any): any => {
  if (!document) {
    return {};
  }

  const { homepageRibbonBackgroundColor, newsRibbonCollapsible, ribbonBackgroundColor } = params;

  const backgroundColor = resolveColorName({
    rawVal: isTransparent ? homepageRibbonBackgroundColor : ribbonBackgroundColor,
  });
  const theme = resolveTheme('bg-color')({ rawVal: backgroundColor });

  return {
    backgroundColor,
    detailContent: document?.detailContent ? resolveRTC({ rawVal: document.detailContent }) : '',
    primaryCTA: document?.primaryCTA ? resolveLink({ rawVal: document.primaryCTA }) : {},
    secondaryCTA: document?.secondaryCTA ? resolveLink({ rawVal: document.primaryCTA }) : {},
    htmlBanner: document?.html || '',
    scriptsBanner: document?.scripts || '',
    stylesBanner: document?.styles || '',
    template: document?.contentType || '',
    collapsible: resolveBool({ rawVal: newsRibbonCollapsible }),
    theme,
  };
};
